/* global $ Bugsnag window */

const env                       = require('../env')
const utils                     = require('../utils')
const applyOrganisationBranding = require('../applyOrganisationBranding')
const applyOrganisationAssets   = require('../applyOrganisationAssets')
const {query, baseurl}          = env

const handleError = (userTitle, userMessage, errorText, error) => {
    const $404 = $('.four-oh-four')

    $404.find('h2').text(userTitle)
    $404.find('p').text(userMessage)

    $("#loading-div").fadeOut(400, () => {
        $404.fadeInCss()
    })

    Bugsnag.notifyException(`TokenError: ${errorText}`, error)
}

const buildOrgUrl = (slug, errType) => {
    const {protocol, host} = window.location

    return `${protocol}//${host}/${slug}?err=${errType}`
}

// Get the details relating to the token
$.ajax({
    method   : 'GET',
    url      : `${baseurl}/credentials/token/${query.t}`,
    dataType : 'json',
    success  : data => {
        if (data.user) {
            if (env.route === 'beta') {
                data.organisation.activeAppVersion = 2
            }

            if (data.expired) {
                window.location = buildOrgUrl(data.organisation.slug, 'expired')

                return

                // return handleError(
                //     "That token has expired",
                //     "The link we emailed you is only valid for 24 hours. " +
                //     "Please return to the credential lander and try again.",
                //     "ExpiredToken"
                // )
            }

            if (data.claimed) {
                window.location = buildOrgUrl(data.organisation.slug, 'claimed')

                return

                // return handleError(
                //     "That token has already been used",
                //     "Your account password has already been set using this link.",
                //     "ClaimedToken"
                // )
            }

            $('#content-wrap h2').eq(0)
            .html(data.user.first ? `Hi ${data.user.first}, let’s set a new password.` : 'Let’s set a new password.')

            applyOrganisationAssets(data.organisation)
            applyOrganisationBranding(data.organisation)
        } else {
            handleError(
                "Something went wrong",
                "We could not connect to our servers, please double check your internet connection and try again.",
                "No Token Data"
            )
        }
    },

    error : (jqXHR, textStatus, errorThrown) => {
        if (jqXHR.status === 404) {
            return handleError(
                "Invalid token",
                "We could not find that token. Please ensure you copied the link emailed to you correctly.",
                textStatus,
                errorThrown
            )
        }

        handleError(
            "Something went wrong",
            "We could not connect to our servers, please double check your internet connection and try again.",
            textStatus,
            errorThrown
        )
    }
})

$('form').submit(event => {
    event.preventDefault()

    const password = $("#password").val()

    if (password.length === 0) {
        return utils.showErrorMessage("Please enter a password")
    }

    utils.showLoadingState()

    // Get the details relating to the token
    $.ajax({
        method      : 'POST',
        url         : `${baseurl}/credentials/token/${query.t}`,
        data        : JSON.stringify({
            password,
            beta : env.route === 'beta'
        }),
        dataType    : 'json',
        contentType : 'text/plain',
        success     : data => {
            if (data.success) {
                if (data.email) {
                    $("#step-2-copy").text(`Log in using ${data.email} and the password you've just created.`) // eslint-disable-line
                }

                const $wrap    = $("#content-wrap")
                const $content = $wrap.children()
                const $inner   = $content.children()
                const $footer  = $('footer')
                const $form    = $inner.find('form')
                const $h2      = $inner.find('h2').eq(0)

                const offset = $inner.offset()

                $content.addClass('hide-img')

                $h2.fadeTo(275, 0)
                $footer.fadeTo(275, 0)

                $form.fadeTo(300, 0, () => {
                    $content.css('paddingTop', offset.top)
                    $("body").addClass('mobile')
                    $form.hide()
                    $h2.hide()

                    $("#token-success-wrap").fadeInCss()

                    $footer.fadeTo(300, 1)
                })
            } else {
                return utils.showErrorMessage(data.errors && data.errors.length && data.errors[0].message ||
                    "There was an issue processing your request. " +
                    "Please contact us at hello@namesandfaces.co."
                )
            }
        },

        error : (jqXHR, textStatus, errorThrown) => {
            utils.hideLoadingState()

            if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.length) {
                return utils.showErrorMessage(
                    jqXHR.responseJSON.errors[0].message
                )
            }

            return utils.showErrorMessage(
                "There was an issue processing your request. " +
                "Please contact us at hello@namesandfaces.co."
            )
        }
    })
})



/** WEBPACK FOOTER **
 ** ./js/credentials/routes/token.js
 **/